<div class="empty">
  <img src="assets/icons/icon-prescription-empty.svg" alt="">
  <div class="title">No Orders</div>
</div>